// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"712a9443","22":"88c0e659","49":"a6a64028","81":"af267d18","223":"ffc5e7d2","232":"c45cd2bc","325":"56b70201","682":"e1d8e920","813":"a9c2958b","858":"fb9c46e5","905":"24a8fc7e","967":"6214fcd6"}[chunkId] + ".chunk.js";
};